export const incNumber = () => {
  return {
    type: "INCREMENT",
  };
};

export const decNumber = () => {
  return {
    type: "DECREMENT",
  };
};

export const clearNumber = () => {
  return {
    type: "CLEAR_ALL",
  };
};